import { render, staticRenderFns } from "./UploadInterface.vue?vue&type=template&id=4267ea75&"
import script from "./UploadInterface.vue?vue&type=script&lang=js&"
export * from "./UploadInterface.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports